import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'

class Slide extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)
    this.i = 0

    this.ref = {
      img: []
    }
  }

  mount() {
    this.startImages()
  }

  startImages(){
    let num = gsap.utils.wrap(0, this.ref.img.length , this.i++)
    console.log(num);
    $('.slide-image.is-visible').removeClass('is-visible')

    $(this.ref.img[num]).addClass('is-visible')
    this.delayedCall = gsap.delayedCall(2, this.startImages.bind(this));
  }

  stopImages(){
    this.delayedCall.kill()
  }

  unmount() {
    stage.removeAllListeners();
  }


  resize(e){

    // this.ref.container.dataset.h = $(this.ref.container).height()
    // this.ref.container.dataset.top = $(this.ref.container).offset().top
    this.render(e)

  }




}



module.exports = Slide
